import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import Page1 from "./Pages/Page1";
import {
  caaqmsDataType,
  CurrentCaaqmsData,
  CurrentCaaqmsRes,
  dataType,
} from "./Pages/type";
import Page3 from "./Pages/Page3";
import { getAllStationAQIData } from "./api/getAllStationAQIData";
import { getAllStationAQIDataEMIS } from "./api/getAQIAllStationDataEMIS";
import { transformAQI } from "./utils/aqi";
import { AQIDataItem, NoiseDataItem } from "./utils/types";
import { getNoiseData } from "./api/getNoiseData";

export default function App() {
  const [AQIInfo, setAQIInfo] = useState<dataType | undefined>();
  const [currentTempData, setCurrentTempData] = useState<
    CurrentCaaqmsData | undefined
  >();

  const [noiseData, setNoiseData] = useState<NoiseDataItem[]>([]);

  const [aqiData, setAQIData] = useState<AQIDataItem[]>([]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyC6IjsKHi8RLOzm7oGGS9vw0uYQcs87nYA",
    // googleMapsApiKey: "AIzaSyAut8wMgiwUlNdnp0BGlpbG4Jc0umurpM0",
  });
  // AIzaSyC6IjsKHi8RLOzm7oGGS9vw0uYQcs87nYA
  // AIzaSyAut8wMgiwUlNdnp0BGlpbG4Jc0umurpM0

  const [AQIColor, setAPIColor] = useState({
    color: "#FFF500",
    type: "Moderate",
  });

  const updateAQIData = async () => {
    const aqi = await getAllStationAQIData();
    if (aqi.status === 200) {
      console.log("hello");
      const newData = transformAQI(aqi.data.data);
      console.log("newData.length", newData.length);
      setAQIData(newData);
    } else {
      const emisAQI = await getAllStationAQIDataEMIS();
      if (emisAQI.status === 200) {
        // dispatch(setStatus({aqi: 'loaded'}));
        const newData = transformAQI(emisAQI.data.data);
        console.log(newData);
        setAQIData(newData);
      } else {
        // dispatch(setStatus({aqi: 'error'}));
      }
    }
  };
  const updateNoiseData = async () => {
    const noise = await getNoiseData();
    console.log("noise ===>", noise);
    if (noise.status === 200) {
      setNoiseData(noise?.data?.data);
    } else {
    }
  };

  useEffect(() => {
    updateNoiseData();
    updateAQIData();
  }, []);
  // const GetInformationHandler = async ({}: {}) => {
  //   await fetch(
  //     ` https://caaqms.wbpcb.wtlprojects.com:9100/v1.0/sens/real/get_24h_aqi?station_id=6`
  //   )
  //     .then((response) => response.json())
  //     .then((result: caaqmsDataType) => {
  //       if (result?.data) setAQIInfo(result?.data[0]);
  //       getColorCodeHandler({ aqi: result?.data[0]?.AQI });
  //     })
  //     .catch((error) => console.log(error));
  // };

  // const GetCurrentTemp = async () => {
  //   await fetch(
  //     `https://caaqms.wbpcb.wtlprojects.com:9100/v1.0/sens/real/get_current?station_id=6`
  //   )
  //     .then((response) => response.json())
  //     .then((result: CurrentCaaqmsRes) => {
  //       if (result?.data) setCurrentTempData(result?.data);
  //     })
  //     .catch((error) => console.log(error));
  // };

  // useEffect(() => {
  //   const fetchData = () => {
  //     GetInformationHandler({});
  //   };
  //   fetchData();

  //   const intervalId = setInterval(fetchData, 30 * 60 * 1000); // 10 minutes in milliseconds
  //   return () => clearInterval(intervalId);
  // }, []);

  // useEffect(() => {
  //   const fetchData = () => {
  //     GetCurrentTemp();
  //   };
  //   fetchData();

  //   const intervalId = setInterval(fetchData, 5 * 60 * 1000); // 10 minutes in milliseconds
  //   return () => clearInterval(intervalId);
  // }, []);

  return (
    <>
      <Swiper
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={true}
        pagination={false}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper bg-[#181818]"
      >
        <SwiperSlide>
          <Page1
            isLoaded={isLoaded}
            AQIInfo={AQIInfo}
            AQIColor={AQIColor}
            currentTempData={currentTempData}
            aqiData={aqiData}
          />
        </SwiperSlide>

        <SwiperSlide>
          <Page3 noiseData={noiseData} isLoaded={isLoaded} />
        </SwiperSlide>
      </Swiper>
    </>
  );
}
